"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouteData = RouteData;
exports.withRouteData = withRouteData;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _useRouteData = _interopRequireDefault(require("../hooks/useRouteData"));
function RouteData(_ref) {
  var children = _ref.children;
  return children((0, _useRouteData["default"])());
}
function withRouteData(Comp) {
  return function componentWithRouteData(props) {
    var routeData = (0, _useRouteData["default"])();
    return /*#__PURE__*/_react["default"].createElement(Comp, (0, _extends2["default"])({}, props, routeData));
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9icm93c2VyL2NvbXBvbmVudHMvUm91dGVEYXRhLmpzIl0sIm5hbWVzIjpbIlJvdXRlRGF0YSIsImNoaWxkcmVuIiwid2l0aFJvdXRlRGF0YSIsIkNvbXAiLCJjb21wb25lbnRXaXRoUm91dGVEYXRhIiwicHJvcHMiLCJyb3V0ZURhdGEiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUVPLFNBQVNBLFNBQVQsT0FBaUM7QUFBQSxNQUFaQyxRQUFZLFFBQVpBLFFBQVk7QUFDdEMsU0FBT0EsUUFBUSxDQUFDLCtCQUFELENBQWY7QUFDRDs7QUFFTSxTQUFTQyxhQUFULENBQXVCQyxJQUF2QixFQUE2QjtBQUNsQyxTQUFPLFNBQVNDLHNCQUFULENBQWdDQyxLQUFoQyxFQUF1QztBQUM1QyxRQUFNQyxTQUFTLEdBQUcsK0JBQWxCO0FBQ0Esd0JBQU8sZ0NBQUMsSUFBRCxnQ0FBVUQsS0FBVixFQUFxQkMsU0FBckIsRUFBUDtBQUNELEdBSEQ7QUFJRCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCB1c2VSb3V0ZURhdGEgZnJvbSAnLi4vaG9va3MvdXNlUm91dGVEYXRhJ1xuXG5leHBvcnQgZnVuY3Rpb24gUm91dGVEYXRhKHsgY2hpbGRyZW4gfSkge1xuICByZXR1cm4gY2hpbGRyZW4odXNlUm91dGVEYXRhKCkpXG59XG5cbmV4cG9ydCBmdW5jdGlvbiB3aXRoUm91dGVEYXRhKENvbXApIHtcbiAgcmV0dXJuIGZ1bmN0aW9uIGNvbXBvbmVudFdpdGhSb3V0ZURhdGEocHJvcHMpIHtcbiAgICBjb25zdCByb3V0ZURhdGEgPSB1c2VSb3V0ZURhdGEoKVxuICAgIHJldHVybiA8Q29tcCB7Li4ucHJvcHN9IHsuLi5yb3V0ZURhdGF9IC8+XG4gIH1cbn1cbiJdfQ==
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/home/runner/work/shoutout_site/shoutout_site/node_modules/react-static/lib/browser/components/RouteData.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/home/runner/work/shoutout_site/shoutout_site/node_modules/react-static/lib/browser/components/RouteData.js");
  }
}();